import PageContent from '../components/PageContent';
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';

function Who() {
  return (
    <PageLayout>
      <PageTitle>
        Who?
      </PageTitle>
      <PageContent>
        Who is this?
      </PageContent>
    </PageLayout>
  );
}

export default Who;
